<template>
  <div class="content">
    <div class="content-item">
      <div class="box-head">
        <div class="box-title">
          <img src="/static/img/jt.png" />
          <div>在线设备</div>
        </div>
        <div class="box-line-1"></div>
        <div class="box-line-2"></div>
        <div class="box-line-3"></div>
        <div class="box-line-4"></div>
      </div>
      <div class="box-body">
        <div class="title">在线设备</div>
        <div class="time">
          <span class="time-1">{{ allData.online }}</span>
          <span class="time-2">台</span>
        </div>
      </div>
    </div>
    <div class="content-item">
      <div class="box-head">
        <div class="box-title">
          <img src="/static/img/jt.png" />
          <div>设备联网率</div>
        </div>
        <div class="box-line-1"></div>
        <div class="box-line-2"></div>
        <div class="box-line-3"></div>
        <div class="box-line-4"></div>
      </div>
      <div class="box-body">
        <div class="title">设备联网率</div>
        <div class="act com-container">
          <div class="com-chart" ref="stock_ref"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      chartInstance: null,
      allData: {
        online: 0,
        value: 0,
      },
      currentIndex: 0, // 当前显示的数据
      timerId: null, // 定时器的标识
    };
  },
  mounted() {
    this.initChart();
    this.getData();
    window.addEventListener("resize", this.screenAdapter);
    this.screenAdapter();
  },
  destroyed() {
    window.removeEventListener("resize", this.screenAdapter);
    clearInterval(this.timerId);
  },
  methods: {
    initChart() {
      this.chartInstance = this.$echarts.init(this.$refs.stock_ref, "chalk");
      const initOption = {};
      this.chartInstance.setOption(initOption);
    },
    async getData() {
      // 获取服务器的数据, 对this.allData进行赋值之后, 调用updateChart方法更新图表
      // const { data: ret } = await this.$http.get("stock");
      const { data: ret } = await axios.get("/right-top");
      this.allData = ret;
      this.updateChart();
      this.startInterval();
    },
    updateChart() {
      // 处理图表需要的数据
      const titleFontSize = (this.$refs.stock_ref.offsetWidth / 100) * 3.6;
      const innerRadius = titleFontSize * 2;
      const outterRadius = innerRadius * 1.125;

      const seriesArr = [
        {
          type: "gauge",
          detail: {
            show: true,
            // color: "rgba(16,242,251, 1)",
            fontSize: titleFontSize * 6,
            fontWeight: "bold",
            offsetCenter: [0, "65%"],
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: titleFontSize * 4,
              color: [
                [0.2, "#fa0"],
                [0.8, "#63869e"],
                [1, "#91c7ae"],
              ],
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          progress: {
            show: true, // 是否显示进度条
            itemStyle: {
              color: "rgba(191, 110, 110, 1)",
              borderWidth: 2.5,
            },
          },
          radius: "95%",
          splitLine: {
            show: false, // 分割线
          },
          title: {
            show: false,
          },
          detail: {
              fontSize: 20,
              offsetCenter: [0, "70%"],

            formatter: function (value) {
              return value.toFixed(0) + "%";
            },
          },
          data: [
            {
              value: this.allData.value,
            },
          ],
        },
      ];
      const dataOption = {
        series: seriesArr,
      };
      this.chartInstance.setOption(dataOption);
    },
    screenAdapter() {
      const titleFontSize = (this.$refs.stock_ref.offsetWidth / 100) * 3.6;
      const adapterOption = {};
      this.chartInstance.setOption(adapterOption);
      this.chartInstance.resize();
    },
    startInterval() {
      if (this.timerId) {
        clearInterval(this.timerId);
      }
      this.timerId = setInterval(() => {
        this.updateChart(); // 在更改完currentIndex之后 , 需要更新界面
      }, 5000);
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  display: flex;
  justify-content: space-between;
  height: 100%;
  .content-item {
    width: 48%;
    display: flex;
    flex-direction: column;
    .box-head {
      position: relative;
      .box-title {
        display: flex;
        align-items: center;
        padding: 10px 7px;
        border-bottom: 1px solid #0087f9;
        div {
          color: #00edff;
          margin-left: 0.625rem;
          font-size: 1.25rem;
        }
        span {
          color: #0087f9;
          font-size: 0.875rem;
          align-self: end;
          margin-left: 0.625rem;
        }
      }
    }
    .box-body {
      flex: 1;
      background-color: rgba(7, 65, 122, 0.2);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .title {
        background: url("/static/img/tk.png");
        background-repeat: no-repeat;
        background-size: cover;
        -webkit-background-size: cover;
        -o-background-size: cover;
        background-position: center 0;
        padding: 0.3125rem 1.25rem;
        font-weight: bold;
        margin-top: 1.25rem;
      }
      .time {
        background: url("/static/img/zxsb@3x.png");
        background-repeat: no-repeat;
        background-size: cover;
        -webkit-background-size: cover;
        -o-background-size: cover;
        background-position: center 0;
        margin-top: 1.25rem;
        height: 120px;
        width: 120px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .time-1 {
          font-weight: bold;
          color: #00edff;
          font-size: 1.4rem;
        }
        .time-2 {
          font-size: 0.75rem;
          color: #00edff;
        }
      }
      .act {
        margin-top: 1.25rem;
        height: 120px;
        width: 120px;
      }
    }
  }
}

.box-line-1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 10px;
  height: 10px;
  border-top: 1px solid #44c4ff;
}
.box-line-2 {
  position: absolute;
  top: 0;
  right: 0;
  width: 10px;
  height: 10px;
  border-top: 1px solid #44c4ff;
}
.box-line-3 {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 10px;
  height: 10px;
  border-bottom: 1px solid #44c4ff;
}
.box-line-4 {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 10px;
  height: 10px;
  border-bottom: 1px solid #44c4ff;
}
</style>
